export default __webpack_public_path__ + "static/media/pdf.9d453ce7.png";